import React, { useState } from 'react';
import { BookOpenIcon, MapPinIcon } from 'lucide-react';
import { ImageLightbox } from '../components/ImageLightbox';
import { covers, magazinePages } from '../data/magazine';
import { contact, magazine } from '../data/event';
import type { GalleryImage } from '../types/showcase';
export function Magazine() {
  const [gallery, setGallery] = useState<GalleryImage[]>(magazinePages);
  const [index, setIndex] = useState<number | null>(null);
  const openPage = (images: GalleryImage[], i: number) => {
    setGallery(images);
    setIndex(i);
  };
  return <div data-id="element-305" data-mp="1h18aubd98wff">
      <section className="border-b border-line bg-canvas" data-id="element-306" data-mp="1h0p13hxrdech">
        <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 lg:grid-cols-12 lg:items-end lg:px-8 lg:py-16" data-id="element-307" data-mp="1gz45rq3mdrdk">
          <div className="lg:col-span-7" data-id="element-308" data-mp="1c0as9xoc20de">
            <h1 className="font-display text-5xl font-bold uppercase text-navy" data-id="element-309" data-mp="173ao5sb1n7ox">Showcase Magazine</h1>
            <p className="mt-3 max-w-2xl text-lg text-muted" data-id="element-310" data-mp="132i9uknbecls">
              The entire 2026 magazine, ready to browse. Tap any page to read it full screen and flip through with the
              arrows.
            </p>
            <button type="button" onClick={() => openPage(magazinePages, 0)} className="mt-6 inline-flex items-center gap-2 rounded-md bg-orange-deep px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 hover:bg-orange-deeper" data-id="element-311" data-mp="30vqrvafx4qwl">
              <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-312" data-mp="3euqeydns8xqn" />
              Start reading
            </button>
          </div>
          <div className="rounded-xl border border-line bg-white p-5 lg:col-span-5" data-id="element-313" data-mp="35t91l31rfa5n">
            <p className="font-semibold text-ink" data-id="element-314" data-mp="35vlh79k1p8fj">Pick up a hard copy</p>
            <p className="mt-1 text-sm text-muted" data-id="element-315" data-mp="39t9gspwonpdr">Available at the CCCIA office starting {magazine.pickupDate}.</p>
            <p className="mt-3 flex gap-2 text-sm text-ink" data-id="element-316" data-mp="1ug6lsa7hiomj">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange-deep" aria-hidden="true" data-id="element-317" data-mp="1ygqg760obe4z" />
              {contact.street}, {contact.city}
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-id="element-318" data-mp="3w4kldpwbdswi">
        <h2 className="font-display text-3xl font-bold uppercase text-ink" data-id="element-319" data-mp="3rc17ssxmmxrp">3 unique covers — one each weekend</h2>
        <ul className="mt-8 grid grid-cols-3 gap-4 md:gap-8" data-id="element-320" data-mp="3me817ysew1qw">
          {covers.map((c, i) => <li key={c.src} data-id="element-321" data-mp="3ic4ol6u0ar41" data-mpi={i}>
              <button type="button" onClick={() => openPage(covers, i)} className="group block w-full text-left focus-visible:outline-none" data-id="element-322" data-mp="3idfsd6ngbyv5">
                <span className="block overflow-hidden rounded-lg border border-line shadow-sm group-focus-visible:ring-2 group-focus-visible:ring-navy" data-id="element-323" data-mp="38dxbx06r2v7u">
                  <img src={c.src} alt={c.alt} className="aspect-[791/1024] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" loading="lazy" data-id="element-324" data-mp="16mtw7wi06qgf" />
                </span>
                <span className="mt-3 block text-sm font-medium text-ink" data-id="element-325" data-mp="1e51l6unlsqb3">{c.caption}</span>
              </button>
            </li>)}
        </ul>
      </section>

      <section className="border-t border-line bg-canvas" data-id="element-326" data-mp="1nvmrz5dfl153">
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8" data-id="element-327" data-mp="1nv4nxmkj1imm">
          <div className="flex items-end justify-between gap-4" data-id="element-328" data-mp="r5vpojywe9oq">
            <h2 className="font-display text-3xl font-bold uppercase text-ink" data-id="element-329" data-mp="r7qa7x69bzsa">All pages</h2>
            <p className="text-sm text-muted" data-id="element-330" data-mp="v91sfhmsxiqg">{magazinePages.length} pages</p>
          </div>
          <ul className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6" data-id="element-331" data-mp="1084vwxn4vgwb">
            {magazinePages.map((p, i) => <li key={p.src} data-id="element-332" data-mp="2bm0b26e1fpnj" data-mpi={i}>
                <button type="button" onClick={() => openPage(magazinePages, i)} className="group block w-full text-left focus-visible:outline-none" data-id="element-333" data-mp="2bkp7a6klehwf">
                  <span className="block overflow-hidden rounded-md border border-line bg-white group-hover:border-navy group-focus-visible:ring-2 group-focus-visible:ring-navy" data-id="element-334" data-mp="3pjcsoiy02v05">
                    <img src={p.src} alt={p.alt} className="aspect-[791/1024] w-full object-cover" loading="lazy" data-id="element-335" data-mp="2e3wbj5oeyi6" />
                  </span>
                  <span className="mt-2 block text-xs font-medium text-muted" data-id="element-336" data-mp="caqe1z2ph9fz">{p.caption}</span>
                </button>
              </li>)}
          </ul>
        </div>
      </section>

      <ImageLightbox images={gallery} index={index} onClose={() => setIndex(null)} onChange={setIndex} data-id="element-337" data-mp="l30qzo4zjt0x" />
    </div>;
}